import {Component, Input} from '@angular/core';
import {MatDialog} from "@angular/material";
import {MailTemplate} from "../../../../classes/mailTemplate";
import {kanMailTemplatesService} from "../../../services/services/templates";
import {kanMailTemplateDialog} from "../../dialogs/mail-template-dialog/component";

@Component({
    selector: 'kan-mail-templates',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
})
export class kanMailTemplates {
    @Input() selectedTab: number;
    public templates: MailTemplate[];

    constructor(private dialog: MatDialog,
                private templatesService: kanMailTemplatesService) {
    }

    ngOnInit(): void {
        this.getTemplates();
    }

    ngOnChanges(changes): void {
        if (changes.selectedTab.currentValue === 3) {
            this.getTemplates();
        }
    }

    public getTemplates(): void {
        this.templatesService.getTemplates()
            .then((templates) => {
                this.templates = templates;
            })
            .catch((error) => {
                console.log(error);
            })
    }

    public openDialog(event: any) {
        let dialogRef = this.dialog.open(kanMailTemplateDialog, {
            disableClose: true,
            width: '800px'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'add') {
                this.getTemplates();
            }
        });
    }

    public editTemplateDialog(event, template) {
        let dialogRef = this.dialog.open(kanMailTemplateDialog, {
            data: {
                template: template
            },
            disableClose: true,
            width: '800px'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'update') {
                this.getTemplates();
            }
        });
    }

    public removeTemplate(event, template) {
        // let dialogRef = this.dialog.open(kanRemoveDialog, {
        //     disableClose: true
        // });
        //
        // dialogRef.afterClosed().subscribe((result) => {
        //     if (result === 'remove') {
        //         this.servicesService.removeService(service)
        //             .then((data) => {
        //                 this.getServices();
        //             });
        //     }
        // });
    }
}



// WEBPACK FOOTER //
// ./src/modules/mails/components/mail-templates/component.ts